import { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { PageTitle } from '../PageTitle';

interface ActionBarHeaderProps {
  readonly title: string;
  readonly children?: ReactNode;
  readonly className?: string;
}

function ActionBarHeader({ title, children, className }: ActionBarHeaderProps) {
  return (
    <header className={twMerge('inline-flex items-center gap-2.5', className)}>
      <PageTitle>{title}</PageTitle>
      <div className="flex flex-auto" />
      {children}
    </header>
  );
}

export { ActionBarHeader };
